const {
  // asyncIterator, // 迭代器不是私有的
  // iterator, // 迭代器不是私有的
  // metadata, // 元数据还没有被浏览器支持
  asyncDispose,
  dispose,
  hasInstance,
  isConcatSpreadable,
  match,
  matchAll,
  replace,
  search,
  species,
  split,
  toPrimitive,
  toStringTag,
  unscopables
} = Symbol

export function isPrivateKey(key: PropertyKey): boolean {
  if (typeof key === 'number') return false
  return (
    key === asyncDispose ||
    key === dispose ||
    key === hasInstance ||
    key === isConcatSpreadable ||
    key === match ||
    key === matchAll ||
    key === replace ||
    key === search ||
    key === species ||
    key === split ||
    key === toPrimitive ||
    key === toStringTag ||
    key === unscopables ||
    key === '__rr_computed_keys' ||
    key === '__rr_deep' ||
    key === '__rr_flags' ||
    key === '__rr_method_keys' ||
    key === '__rr_observe_keys' ||
    key === '__rr_observers' ||
    key === '__rr_parents' ||
    key === '__rr_proxy_keys' ||
    key === '__rr_raw' ||
    key === '__rr_shallow' ||
    key === '__rr_signal_keys' ||
    key === '__rr_signals' ||
    key === '__rr_version' ||
    key === '__defineGetter__' ||
    key === '__defineSetter__' ||
    key === '__iterator__' ||
    key === '__lookupGetter__' ||
    key === '__lookupSetter__' ||
    key === '__proto__' ||
    key === '__r_proxy_raw' ||
    key === '__v_skip' ||
    key === '_isAMomentObject' ||
    key === '$$typeof' ||
    key === '$isDayjsObject' ||
    key === 'constructor' ||
    key === 'hasOwnProperty' ||
    key === 'isPrototypeOf' ||
    key === 'propertyIsEnumerable' ||
    key === 'toLocaleString' ||
    key === 'toString' ||
    key === 'valueOf'
  )
}
